import React from 'react';
import { Page } from '../../components/Routing/Page';
import { ImageBlock } from '../../components/Blocks/ImageBlock';

import bg from "../../assets/jezael-melgoza-975446-unsplash.jpg"
import redondela from "../../assets/Redondela.jpg"
import urzaiz from "../../assets/urzaiz.jpg"
import principe from "../../assets/principe.jpg"
import { ItemParallax } from './../../components/Parallax/ItemParallax';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faMapPin } from '@fortawesome/fontawesome-free-solid';
import "./Marketing.scss";

export class Marketing extends React.PureComponent
{
	render()
	{
		return (
			// <Page id="marketing" title="System3" noCrawl >
			<div id="marketing" >
				<ImageBlock overlay src={bg} >
					<h2>Bienvenido al <span className="highlight">Marketing <span>3</span>.<span>0</span></span></h2>
					<h3>Producción y emisión de video</h3>
					<p>
						Refuerza tu imagen corporativa con una producción audiovisual de calidad cinematográfica, emitida en las zonas más concurridas{'\n\n'}
						Forma parte de un directorio online premium de establecimientos y servicios, con un diseño moderno y creativo.{'\n\n'}
						Incrementa tu presencia en las calles y las redes con un spot comercial de alta calidad que asegurara girar cabezas y atraer clicks.
					</p>
					<ItemParallax id='screen-description' speed={.30} medium up >
						<h3 >
							Localiza nuestras pantallas
						</h3>
					</ItemParallax>
					<ItemParallax speed={.30} medium up >
						<h3>
							Llegar a tanta gente <span className="highlight">nunca fue tan fácil</span>
						</h3>
					</ItemParallax>
					<ItemParallax speed={.30} medium up >
						<ul>
							<li>
								Calidad cinematográfica
							</li>
							<li>
								Ubicaciones estratégicas
							</li>
							<li>
								Envío y recogida de dispositivos
							</li>
							<li>
								Servicio prioritario de instalaciones 
							</li>
						</ul>
						</ItemParallax>
					<ItemParallax id="principe" className="screen-photo" speed={.6} medium up >
						<img src={principe}  />
						<FontAwesomeIcon icon={faMapPin} />
					</ItemParallax>
					<ItemParallax  className="titled-list"  speed={.30} medium up >
						<h3>
						Principe - Vigo
						</h3>
						<ul>
							<li>
								Principal peatonal de la ciudad
							</li>
							<li>
								Barrio más dinámico de Vigo
							</li>
							<li>
								Rodeado de las mejores marcas
							</li>
						</ul>
					</ItemParallax>
					<ItemParallax id="urzaiz" className="screen-photo" speed={.6} medium up >
						<img src={urzaiz}  />
						<FontAwesomeIcon icon={faMapPin} />
					</ItemParallax>
					<ItemParallax  className="titled-list"  speed={.30} medium up >
						<h3>
						Urzaiz - Vigo
						</h3>
						<ul>
							<li>
								Más de 8.000 personas cada dia
							</li>
							<li>
								Ubicación perfecta para transeúntes
							</li>
						</ul>
					</ItemParallax>
					<ItemParallax id="redondela" className="screen-photo" speed={.6} medium up >
						<img src={redondela}  />
						<FontAwesomeIcon icon={faMapPin} />
					</ItemParallax>
					<ItemParallax  className="titled-list"  speed={.30} medium up >
						<h3>
						Redondela
						</h3>
						<ul>
							<li>
								Expande tu negocio con nueva clientela
							</li>
							<li>
								Flujo constante de trafico y transeúntes
							</li>
							<li>
								Principal ciudad dormitorio de Vigo
							</li>
						</ul>
					</ItemParallax>
				</ImageBlock>
			</div>
		);
	}
}